//import api from '@/api/mock';
import API from '@aws-amplify/api';
export default {
  namespaced: true,
  state: {
    calls: null,
    loading: false
  },
  mutations: {
    loading(state, payload) {
      state.loading = payload;
    },
    set(state, calls) {
      state.calls = calls;
      console.log('Set internal calls: ', calls);
    },
    setDetails(state, call) {
      state.calls[call.id].details = call;
      console.log(state.calls);
      console.log('Set internal call: ', call);
    }
  },
  actions: {
    async load({ commit }) {
      try {
        const callsArray = await API.get('ipWayAPI', '/calls');
        const callsObject = {};
        callsArray.forEach(call => {
          callsObject[call.id] = call;
          callsObject[call.id].details = null;
        });
        commit('set', callsObject);
        commit('loading', false);
      } catch (err) {
        console.log(err);
        commit('set', null);
        commit('loading', false);
      }
    },
    async fetch({ commit, dispatch, state }) {
      if (state.calls == null) {
        console.log('fetching call');
        commit('loading', true);
        await dispatch('load');
      }
    },
    async get({ dispatch }) {
      await dispatch('fetch');
    },
    async getDetails({ commit }, { flat, uuid }) {
      const call = await API.get(
        'ipWayAPI',
        '/user/flats/' + flat + '/calls/' + uuid
      );
      console.log(call);
      commit('setDetails', call);
    },
    ['awsauth/setUser']: {
      root: true,
      handler({ commit }, user) {
        //on logout clear gateway from list
        if (!user) {
          commit('set', null);
        }
      }
    }
  }
};
